import { Button, Card, CardContent, CardHeader, Grid, Box, Tabs, Tab, Stack, Typography } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { useState } from "react";
import * as React from 'react'
import { formatCurrency } from "../../../common/util";
import { useForm } from "react-hook-form";
import { useGetAllCourierPartnersCachedQuery } from "../../../redux/commonApiCalls";
import { DownloadExcelMultipleSheets } from "../../../helpers/ExcelGenerator";
import { FormProvider, RHFSelectField } from "../../../common/hook-form";
import _ from "lodash";
import B2bRateCard from "../B2BrateCard";
import PageTitle from "../../../components/PageTitle";
import ProzoDataGrid from "../../../common/ProzoDataGrid";

// A zone entry can come back with no `slab` — a rate card that is only partly
// configured, or a zone the courier has not priced. Those zones simply contribute
// no rows; reading `.slab.map(...)` off them blanked the whole Commercials tab
// with "Cannot read properties of undefined (reading 'map')".
const slabRows = (entry) => (Array.isArray(entry?.slab) ? entry.slab : []);

function RateCard({ data }) {
    const [price, setPrice] = useState([]);
    const [condition, setCondition] = useState("");
    const [zoneSlab, setZoneSlab] = useState("");
    const [slab, setSlab] = useState([]);
    const [allrate, setAllRate] = useState([])
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);
    const filter2 = {
        "andfilter": [{ "field": "is_deleted", "operator": "eq", "value": '0' }],
        "offset": 0,
        "limit": 1000,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType"
    }
    const Region = ["LOCAL", "REGIONAL", "METROS", "ROI", "SPECIAL"];
    const { data: courier = [] } = useGetAllCourierPartnersCachedQuery(filter2)
    const methods = useForm();
    const {
        handleSubmit,
        // setValue,
        // formState: { isSubmitting }
    } = methods;

    function courierPartnerHandle(e) {
        setCondition(e.target.value);
        setPrice("");
    }


    function ZoneHandle(e) {
        setZoneSlab(e.target.value);
        setPrice("");
    }

    // Resolve a rate-card key (cplist[0], usually a prozoId) to its courier
    // account code. The dropdown + table label by account code — not parent
    // name — so two account codes under the same parent (e.g. "Delhivery
    // Surface") stay distinguishable and each maps to its own uploaded pricing.
    const courierByKey = React.useMemo(() => {
        const m = {};
        (courier || []).forEach((c) => {
            if (c?.prozoId) m[c.prozoId] = c;
            if (c?.cpAccountCode) m[c.cpAccountCode] = c;
        });
        return m;
    }, [courier]);
    const accountCodeFor = (key) => courierByKey[key]?.cpAccountCode || key;

    React.useEffect(() => {
        if (data) {
            const filter = data?.sla?.filter((item) => item.active === true)
            // Courier Partner options. The selectable value MUST be cplist[0] (the
            // key the price/zone filters below match on); the label is the account
            // code so duplicate parent names disambiguate. Falls back to the raw
            // key when no courier matches (or the list hasn't loaded yet).
            const seen = new Set();
            const options = [];
            (filter || []).forEach((entry) => {
                const key = entry?.cplist?.[0];
                if (!key || seen.has(key)) return;
                seen.add(key);
                options.push({ value: key, label: accountCodeFor(key) });
            });
            setSlab(options);

            let arr2 = [];
            for (let i = 0; i < filter?.length; i++) {
                const cpList = filter[i]?.cplist?.[0] ? filter[i]?.cplist[0] : "";
                const pro = filter[i].sla;
                const convert = Object.entries(pro).map((e) => (e[1]));
                for (let j = 0; j < convert.length; j++) {
                    for (let k = 0; k < Region.length; k++) {
                        if (convert[j].zoneName === Region[k]) {
                            const minTat = convert[j].minTat;
                            const maxTat = convert[j].maxTat;
                            const tatUnit = convert[j].tatUnit

                            let newArr = slabRows(convert[j]).map((item, index) => {
                                item.cp = accountCodeFor(cpList) + " / " + Region[k]
                                item.minTat = minTat;
                                item.maxTat = maxTat;
                                item.tatUnit = tatUnit;

                                return item;
                            })
                            arr2.push(newArr);
                        }
                    }
                }
                let objArray = _.flatten(arr2)
                objArray.map((item, index) => {
                    item.id = Math.random() * 1000;
                    return item
                })
                setAllRate(objArray)
            }

        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courier, data])


    React.useEffect(() => {
        const newData = data?.sla?.filter((item) => item.active === true)
        let arr = [];
        if (condition === "" && zoneSlab !== "") {
            for (let i = 0; i < newData?.length; i++) {
                const cpList = newData[i]?.cplist?.[0];
                const pro = newData[i].sla;
                const convert = Object.entries(pro).map((e) => (e[1]));
                let newArr = convert.filter((word) => word.zoneName === zoneSlab)
                const maxTat = newArr[0]?.maxTat;
                const minTat = newArr[0]?.minTat;
                const tatUnit = newArr[0]?.tatUnit
                newArr = slabRows(newArr[0]).map((item, index) => {
                    item.cp = accountCodeFor(cpList) + " / " + zoneSlab;
                    item.maxTat = maxTat;
                    item.minTat = minTat;
                    item.tatUnit = tatUnit;

                    return item;
                })
                arr.push(newArr);
                let objArray = _.flatten(arr)
                objArray.map((item, index) => {
                    item.id = Math.random() * 1000;
                    return item;
                })
                // console.log(mainResult2)
                setPrice(objArray);
            }
        }
        if (condition !== "" && zoneSlab === "") {
            let arr2 = [];
            for (let i = 0; i < newData?.length; i++) {
                // const cpList = newData[i]?.cplist[0];
                const cpList = newData[i]?.cplist?.[0];
                if (condition === cpList) {
                    const pro = newData[i].sla;
                    const convert = Object.entries(pro).map((e) => (e[1]));
                    for (let j = 0; j < convert.length; j++) {
                        for (let k = 0; k < Region.length; k++) {
                            if (convert[j].zoneName === Region[k]) {
                                const minTat = convert[j].minTat;
                                const maxTat = convert[j].maxTat;
                                const tatUnit = convert[j].tatUnit
                                let newArr = slabRows(convert[j]).map((item, index) => {
                                    item.cp = accountCodeFor(cpList) + " / " + Region[k]
                                    item.minTat = minTat;
                                    item.maxTat = maxTat;
                                    item.tatUnit = tatUnit;

                                    return item;
                                })

                                arr2.push(newArr);

                            }
                        }
                    }
                    let objArray = _.flatten(arr2)
                    objArray.map((item, index) => {
                        item.id = Math.random() * 1000;
                        return item
                    })
                    // console.log(mainResult)
                    setPrice(objArray)

                }
            }

        }
        if (condition !== "" && zoneSlab !== "") {
            let arr2 = [];
            for (let i = 0; i < newData?.length; i++) {
                // console.log(data.sla[i]);
                const cpList = newData[i]?.cplist?.[0];

                if (condition === cpList) {
                    const pro = newData[i].sla;
                    const convert = Object.entries(pro).map((e) => (e[1]));
                    let newArr = convert.filter((word) =>
                        word.zoneName === zoneSlab
                    )
                    arr2 = newArr;

                }
                let objArray = _.flatten(arr2)
                // console.log(objArray)
                const minTat = objArray[0]?.minTat;
                const maxTat = objArray[0]?.maxTat;
                const tatUnit = objArray[0]?.tatUnit
                // console.log(minTat)
                // const newObj = objArray?.slab
                var userIds = _.map(objArray, _.property('slab'));
                const mainResult = _.compact(_.flatten(userIds))
                // console.log(mainResult)
                const mainResult2 = mainResult.map((item, index) => {
                    item.id = Math.random() * 1000;
                    item.cp = accountCodeFor(condition) + " / " + zoneSlab;
                    item.minTat = minTat;
                    item.maxTat = maxTat;
                    item.tatUnit = tatUnit;


                    return item;
                })
                setPrice(mainResult2)

            }
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zoneSlab, condition, courier])

    const columns = [
        {
            field: 'cp',
            headerName: 'Courier partner/ Zone Name',
            width: 320,
        },
        {
            field: 'startWt',
            headerName: 'Start Weight (gm)',
            width: 150,
        },

        // {
        //     field: 'minWt',
        //     headerName: 'Min Weight (gm)',
        //     width: 150,
        // },
        {
            field: "maxWt",
            headerName: "Max weight (gm)",
            width: 150,

        },
        {
            field: 'price',
            headerName: 'Price',
            width: 100,
            renderCell: (col) => {
                const p = col.row?.price;
                return (p != null && p !== '') ? ("₹ " + Number(p).toFixed(2)) : "-";
            }

        },
        {
            field: 'additionalUnit',
            headerName: 'Additional Unit(gm)',
            width: 100,
            renderCell: (col) => {
                return (col.row?.additionalUnit)
            }
        },
        {
            field: 'additionalUnitRate',
            headerName: 'Additional Unit Rate',
            width: 100,
            renderCell: (col) => {
                return (col.row?.additionalUnitRate)
            }
        },
        {
            field: 'volumetricCoeff',
            headerName: 'Volumetric Coefficient ',
            width: 100,
            renderCell: (col) => {
                return (col.row?.volumetricCoeff)
            }
        },
        {
            field: 'taxPercent',
            headerName: 'Tax',
            width: 100,
            renderCell: (col) => {
                return (col.row?.taxPercent ? (col.row?.taxPercent + " %") : "-")
            }
        },
        {
            field: 'surchargePercent',
            headerName: 'Surcharge %',
            width: 110,
            renderCell: (col) => {
                return (col.row?.surchargePercent ? (col.row?.surchargePercent + " %") : "-")
            }
        },
        {
            field: 'docketCharge',
            headerName: 'Docket Charge',
            width: 110,
            renderCell: (col) => {
                return (col.row?.docketCharge)
            }
        },
        {
            field: 'invoicePercentCOD',
            headerName: 'Invoice Percentage for COD %',
            width: 130,
            renderCell: (col) => {
                return (col.row?.invoicePercentCOD ? (col.row?.invoicePercentCOD + " %") : "-")

            }
        },
        {
            field: 'codOperator',
            headerName: 'COD Operator',
            width: 110,
            renderCell: (col) => {
                return (col.row?.codOperator)
            }
        },
        {
            field: 'withQCCharge',
            headerName: 'RVP With QC ',
            width: 120,
            renderCell: (col) => {
                return (col.row?.withQCCharge ? ("₹ " + Number(col.row?.withQCCharge).toFixed(2)) : "-")
            }
        },
        {
            field: 'withoutQCCharge',
            headerName: 'RVP Without QC',
            width: 150,
            renderCell: (col) => {
                return (col.row?.withoutQCCharge ? ("₹ " + Number(col.row?.withoutQCCharge).toFixed(2)) : "-")
            }
        },

        {
            field: 'fixedCODCharges',
            headerName: 'COD Charges',
            width: 130,
            renderCell: (col) => {
                return (col.row?.fixedCODCharges ? ("₹" + Number(col.row?.fixedCODCharges).toFixed(2)) : "-")

            }
        },
        {
            field: 'minTat',
            headerName: 'Min TAT',
            width: 100,

        },
        {
            field: 'maxTat',
            headerName: 'Max TAT',
            width: 100,

        },
        // {
        //     field: 'tatUnit',
        //     headerName: 'TAT Unit',
        //     width: 100,

        // },
        {
            field: 'rtoPercentOfForward',
            headerName: 'RTO (Forward %)',
            width: 100,
            renderCell: (col) => {
                return (col.row?.rtoPercentOfForward ? (col.row?.rtoPercentOfForward + " %") : "-")
            }
        },
    ]
    function onSubmit() {
    }
    const sheets = [
        {
            name: "Merchant Rate Card",
            data: price.length > 0 ? price : allrate,
            columns: [
                {
                    label: 'Courier partner/ Zone Name',
                    value: (col) => {
                        return col.cp
                    }
                },
                {
                    label: 'Start Weight(gm)',
                    value: (col) => col.startWt,
                },
                {
                    label: 'Max Weight(gm)',
                    value: (col) => col.maxWt
                },
                {
                    label: 'Price',
                    value: (col) => formatCurrency(col.price)
                },
                {
                    label: 'Additional Unit(gm)',
                    value: (col) => (col.additionalUnit)
                },
                {
                    label: 'Additional Unit Rate',
                    value: (col) => formatCurrency(col.additionalUnitRate)
                },
                {
                    label: 'Volumetric Coefficient',
                    value: (col) => (col.volumetricCoeff
                    )
                },
                {
                    label: 'Tax(%)',
                    value: (col) => (col.taxPercent ? (col.taxPercent + " %") : "-")
                },
                {
                    label: 'Fuel Surcharge(%)',
                    value: (col) => col.surchargePercent ? (col.surchargePercent + " %") : "-"
                },
                {
                    label: 'Docket Charge',
                    value: (col) => formatCurrency(col.docketCharge)
                },
                {
                    label: 'Invoice Percentage for COD',
                    value: (col) => col.invoicePercentCOD ? (col.invoicePercentCOD + " %") : "-"
                },
                {
                    label: 'COD Operator(Min/Max)',
                    value: (col) => col.codOperator
                },
                {
                    label: 'Fixed COD Charge',
                    value: (col) => formatCurrency(col.fixedCODCharges)
                },
                {
                    label: 'RVP With QC',
                    value: (col) => col.withQCCharge
                },
                {
                    label: 'RVP Without QC',
                    value: (col) => col.withoutQCCharge
                },
                {
                    label: 'RTO (Forward %)',
                    value: (col) => col.rtoPercentOfForward ? (col.rtoPercentOfForward + " %") : "-"
                },
                {
                    label: 'MIN TAT',
                    value: (col) => col.minTat + " " + col.tatUnit
                },
                {
                    label: 'MAX TAT',
                    value: (col) => col.maxTat + " " + col.tatUnit
                },
            ]
        }
    ]

    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };
    return (
        <div>
            <PageTitle>Courier Rate Card {data?.name ? " / " + data?.name : ""}</PageTitle>
            {/* <Grid sx={{ paddingBottom: 2 }}>
                {data?.sla?.length > 0 &&
                    <Card>
                        <CardHeader title='Merchant Rate Card (B2C)' action={
                            <DownloadExcelMultipleSheets sheets={sheets} filename="Merchant Rate Card" />}
                        />
                        <CardContent>
                            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={2} alignItems="center" paddingBottom={1}>
                                    <Grid item xs={4}>
                                        <RHFSelectField name="CourierPartner" width="100%" label="Courier Partner" value={condition} options={slab || [""]}
                                            onChange={courierPartnerHandle} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <RHFSelectField name="ZoneName" width="100%" label="Zone Name" value={zoneSlab} options={Region.map((op) => ({ label: _.startCase(op), value: op }))}
                                            onChange={ZoneHandle} />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <Button onClick={() => {
                                            setPrice("")
                                            setCondition("")
                                            setZoneSlab("")
                                        }}
                                            variant="contained"
                                            size="small"
                                            color="error"
                                        >Reset</Button>
                                    </Grid>
                                </Grid>
                            </FormProvider>
                            {price.length > 0 &&
                                <DataGrid
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                    rows={price ? price : []}
                                    autoHeight={true}
                                    hideFooterPagination={true}
                                />}
                        </CardContent>
                    </Card>
                }
            </Grid>
            <Grid sx={{ paddingBottom: 2 }}>
                <B2bRateCard />
            </Grid> */}
            <Card>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={selectedTab} onChange={handleTabChange} aria-label="notification tabs" >
                        <Tab
                            label={
                                <Stack direction="row" alignItems="center" spacing={2}>
                                    <ShoppingCartIcon />
                                    <span>B2C Rate Card</span>
                                </Stack>
                            }
                        />
                        <Tab
                            label={
                                <Stack direction="row" alignItems="center" spacing={2}>
                                    <BusinessCenterIcon />
                                    <span>B2B Rate Card</span>
                                </Stack>
                            }
                        />
                    </Tabs>
                </Box>
                {/* Rate Card (B2C) Tab Content */}
                {selectedTab === 0 && (
                    <Box >
                        {data?.sla?.length > 0 ?
                            <>
                                <CardHeader
                                    title='Merchant Rate Card (B2C)'
                                    subheader="View pricing details for consumer shipments, including zone-based rates and courier partner settings."
                                    action={
                                        <DownloadExcelMultipleSheets sheets={sheets} filename="Merchant Rate Card" />
                                    }
                                />
                                <CardContent >
                                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                        <Grid container spacing={2} alignItems="center" paddingBottom={1}>
                                            <Grid item xs={4}>
                                                <RHFSelectField name="CourierPartner" width="100%" label="Courier Partner" value={condition} options={slab || [""]}
                                                    onChange={courierPartnerHandle} />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <RHFSelectField name="ZoneName" width="100%" label="Zone Name" value={zoneSlab} options={Region.map((op) => ({ label: _.startCase(op), value: op }))}
                                                    onChange={ZoneHandle} />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button onClick={() => {
                                                    setPrice("")
                                                    setCondition("")
                                                    setZoneSlab("")
                                                }}
                                                    variant="contained"
                                                    size="small"
                                                    color="error"
                                                >Reset</Button>
                                            </Grid>
                                        </Grid>
                                    </FormProvider>
                                    {price.length > 0 &&
                                        // Bounded-height wrapper: the rate card has ~16 wide columns, so the
                                        // grid must scroll horizontally. autoHeight={false} + a fixed-height
                                        // parent gives the DataGrid its own internal vertical + horizontal
                                        // scrollbars (the horizontal bar stays pinned at the bottom of the
                                        // viewport instead of below all rows where it was unreachable).
                                        <Box sx={{ height: 'calc(100vh - 340px)', minHeight: 380, width: '100%' }}>
                                            <ProzoDataGrid
                                                columns={columns}
                                                getRowId={(row) => row.id}
                                                rows={price ? price : []}
                                                autoHeight={false}
                                                rowCount={price?.length || Number.MAX_VALUE}
                                                pagination={true}
                                                paginationMode={'client'}
                                                getRowHeight={() => 25}
                                                page={page}
                                                setPage={setPage}
                                                sizePerPage={sizePerPage}
                                                setSizePerPage={setSizePerPage}
                                            />
                                        </Box>
                                        }
                                </CardContent>
                            </>
                            :
                            <CardContent>
                                <Typography variant="body1" color="text.secondary" align="center" sx={{ py: 4 }}>
                                    No B2C rate card data available for this merchant.
                                </Typography>
                            </CardContent>
                        }
                    </Box>
                )}

                {/* Rate Card (B2B) Tab Content */}
                {selectedTab === 1 && (
                    <B2bRateCard courier={courier} />
                )}
            </Card>

        </div >
    );
}


export default RateCard;
